export default {
  login: {
    title: '设备云管理系统',
    logIn: '登录',
    username: '账号',
    password: '密码'
  },
  //消息提示
  message:{
    setLanguageSuccess:"设置语言成功"
  },
  common:{
    language: "选择语言",
    resetPwd: '修改密码',
    exitMsg: '退出成功！',
    day:'日',
    month: '月',
    year: '年',
  },
  mainHome: {
    renewableEnergy: '新能源',
    powerGeneration: '发电量',
    powertoGrid: '并网电量',
    cleanEnergyConsumption: '新能源消费量',
    peakShavingCapacity: '调峰电量',
    EVChargingCapacity: '充电桩充电量',
    totalPowerConsumption: '总消费电量',
    powerTransformerLoadRatio: '变压器负载率',
    substation: '变压器',
    powerPlantMonthlyConsumption: '每月消费电量',
    carbonNeutral: '碳排数据',
    realTimeData: '实时数据',
    energyConsumption: '能源消耗',
    coalEquivalent: '等价标煤',
    CO2Emissions: '排放量',
    dataTotal: '累计数据',
    CO2Reduction: '减排量',
    CO2ReductionRate: '减排率',
    switchStation: '变电站',
    battery: '储能',
    evc: '充电桩',
    pv: '光伏',
  },
  osState: {
      standbyInitializes: '待机：初始化',
      standbyInsulationImpedanceDetection: '待机：绝缘阻抗检测',
      standbyLightDetection: '待机：光照检测',
      standbyGridDetection: '待机：电网检测',
      starting: '启动',
      gridConnectedRunning: '并网（离网模式：运行）',
      gridConnectedLimitedPower: '并网:限功率',
      gridConnectedSelfReducingRatedPower: '并网:自降额',
      shutdownAbnormal: '关机：异常关机',
      shutdownCommand: '关机：指令关机',
      shutdownOVGR: '关机：OVGR',
      shutdownCommunicationBreak: '关机：通信断链',
      shutdownPowerLimited: '关机：限功率',
      shutdownMannualBoot: '关机：需手动开机',
      shutdownDCSwitchC: '关机：直流开关断开',
      shutdownQuickShutdown: '关机：快速关断',
      shutdownInputUnderpower: '关机：输入欠功率',
      powerGridDispatching: '电网调度：cosϕ-P',
      powerGridDispatchingQU: '电网调度：Q-U',
      powerGridDispatchingPFU: '电网调度：PFU',
      powerGridDispatchingDryContact: '电网调度：干接点',
      powerGridDispatchingQP: '电网调度：Q-P',
      spotReady: '点检就绪',
      spotChecking: '点检中',
      duringInspection: '巡检中',
      AFCIChecking: 'AFCI自检',
      IVScanning: 'IV扫描中',
      DCInputChecking: '直流输入检测',
      runningChargingOffGrid: '运行：脱网充电',
      standbyNoLight: '待机：无光照',
  },
  bwgManage: {
    dianliu : '电流',
    dianya : '电压',
    yougonggonglv: '有功功率',
    wugonggonglv: '无功功率',
    gonglvyinshu: '功率因数',
    dayelec: '日发电量',
    monthelec: '月发电量',
    yearelec: '年发电量',
    PVCS1: '01#并网柜',
    PVCS2: '02#并网柜',
    PVCS3: '03#并网柜',
    PVCS4: '04#并网柜',
    PVCS5: '05#并网柜',
    PVCS6: '06#并网柜',
    PVCS7: '07#并网柜',
    PVCS8: '08#并网柜',
    PVCS9: '09#并网柜',
    PVCS10: '10#并网柜',
    sharpPower: '尖电量',
    peakPower: '峰电量',
    valleyPower: '谷电量'
  },
  nbqList: {
      anzhuangweizhi : '安装位置',
      xinghao : '型号',
      jiaoliugonglv: '交流功率',
      shishi: '实时发电功率',
      dayelec: '当日发电量',
      runstate: '运行状态',
  },
  bwgPowerManage: {
      bwg: '并网柜',
      dianya: '电压',
      dianliu: '电流',
      yougonggonglv: '有功功率',
      wugonggonglv: '无功功率',
      gonglvyinshu: '功率因数',
      elec_day: '日发电量',
      elec_month: '月发电量',
      elec_year: '年发电量',
      shunshifenxi: '瞬时分析',
      data: '数据',
      chart: '图表', time: '时间',
      daySelection: '选择日期',
      zhi: '至',
  },
  photovoltaicPower: {
      nbq: '逆变器',
      position: '安装位置',
      elec_day: '当日发电量',
      model: '型号',
      run_state: '运行状态',
      jialiugonglv: '交流功率',
      ri_elec: '日发电量',
      shishi: '实时发电功率',
      elec_total: '总发电量',
      shunshifenxi: '瞬时分析',
      data: '数据',
      chart: '图表',
      trend: '发电量趋势分析',
      time: '时间',
      daySelection: '选择日期',
      zhi: '至',
      unit:'单位',
      pcs_uab: '电网电压Uab',
      pcs_ubc: '电网电压Ubc',
      pcs_uca: '电网电压Uca',
      pcs_ia: 'A相电流值',
      pcs_ib: 'B相电流值',
      pcs_ic: 'C相电流值',
      pcs_lwpl: '离网频率',
      pcs_pl: '频率',
      pcs_jlldl: '交流漏电流(预留)',
      pcs_zldy: '直流电压',
      pcs_zldl: '直流电流',
      pcs_zzlgl: '总直流功率',
      pcs_scszgl: '输出视在功率',
      pcs_p: '总有功功率P',
      pcs_q: '总无功功率Q',
      pcs_yxzt: 'PCS运行状态',
      pcs_zcdl: 'PCS总充电量',
      pcs_zfdl: 'PCS总放电量',
      pcs_rcdl: '日充电量',
      pcs_rfdl: '日放电量',
      pcs_glys: '功率因数',
      pcs_nbwd: '内部温度',
      pcs_srqwd: '散热器温度',
      bms_soc: 'SOC',
      bms_soh: 'SOH',
      bms_dccyxzt: '电池簇运行状态',
      bms_zt: 'BMS状态',
      bms_v: '总电压',
      bms_i: '电流',
      bms_zgdtdy: '最高单体电压',
      bms_zddtdy: '最低单体电压',
      bms_zgwd: '最高温度',
      bms_zdwd: '最低温度',
      bms_zgsoc: '最高SOC',
      bms_zdsoc: '最低SOC',
      bms_zgdtdybh: '最高单体电压编号',
      bms_zddtdybh: '最低单体电压编号',
      bms_zgwdbh: '最高温度编号',
      bms_zdwdbh: '最低温度编号',
      bms_zdrxcddl: '最大允许充电电流',
      bms_zdrxfddl: '最大允许放电电流',
      bms_cndtdygs: '簇内单体电压个数',
      bms_cndtwdgs: '簇内单体温度个数',
      bms_zddywd: '电池组最大电压电池温度',
      bms_zxdywd: '电池组最小电压电池温度',
      bms_zdwddy: '电池组最大温度电池电压',
      bms_zxwddy: '电池组最小温度电池电压',
      bms_cddlfz: '电池组充电电流限值',
      bms_fddlfz: '电池组放电电流限值',
      collectTime: '采集时间'
  },
  networkDialog: {
      overview: '设备总览',
      photovoltaic: '光伏',
      installedCapacity: '光伏组件',
      PVInverter: '光伏逆变器',
      pcs: '个',
      powerStorage: '储能',
      totalCapacity: '储能总容量',
      outputPower: '输出功率',
      EVCharger: '充电桩',
      DCCharger: '直流快充充电桩',
      ACCharger: '交流充电桩',
      PVPowerGeneration: '光伏发电情况',
      dailyGeneration: '日发电量',
      monthlyGeneration: '月发电量',
      yearlyGeneration: '年发电量',


      frontDailyGeneration: '昨日发电量',
      frontMonthlyGeneration: '上月发电量',
      frontYearlyGeneration: '去年发电量',
      totalPowertoGridYTD: '当年上网电量',
      monthlyRecycleNumbers: '月循环次数',
      EVChargingCapacity: '充电桩充电情况',
      daily: '日充电量',
      monthly: '月充电量',
      yearly: '年充电量',
      radiationComparison: '光照辐射与发电对比',
      EVCOperationRevenue: '充电收益情况',
      gffdl: '光伏发电量',
      zfs: '总辐射',
  },
  roofManage: {
      hj:'环境数据',
      ssfengsu: '实时风速',
      ssfengxiang: '实时风向',
      sswendu: '实时温度',
      ssfuzhaodu: '实时辐照度',
      ljfuzhaodu: '日累计辐照度',
      ssshidu: '实时湿度',
      fuzhaoduquxian: '辐照度曲线',
      fengsufengxiang: '风速风向',
      wenshiduquxian: '温湿度曲线',
      tai: '台逆变器',
      model: '型号',
      jlgl: '交流功率',
      daypower: '当日发电量',
      monthpower: '当月发电量',
      yearpower: '当年发电量',
      ljpower: '累计发电量',
      sspower: '累计消纳率',
      run: '运行数据',
      factory2: '2#厂房',
      factory1_1: '1#厂房',
      factory1_2: '1#厂房-混凝土',
      factoryHV: 'HV车间',
      factoryIRP_1: '绝缘车间',
      factoryIRP_2: '绝缘车间-混凝土',
      factoryLogistics: '生产车间',
      factoryMV: 'MV车间',
      north: '北风',
      northeast: '东北风',
      east: '东风',
      southeast: '东南风',
      south: '南风',
      southwest: '西南风',
      west: '西风',
      northwest: '西北风',
  },
  windPowerGenerationMonitoring: {
      installedCapacity: '装机容量',
      pvCapacity: '光伏容量',
      windPowerCapacity: '风机容量',
      dailyPowerGeneration: '日发电量',
      dailyTCEReduction: '日节约标煤',
      dailyCO2Reduction: '日减排co2',
      monthlyPowerGeneration: '月发电量',
      monthlyTCEReduction: '月节约标煤',
      monthlyCO2Reduction: '月减排co2',
      annualPowerGeneration: '年发电量',
      annualTCEReduction: '年节约标煤',
      annualCO2Reduction: '年减排co2',
      microgridRTPowerGeneration: '微网发电实时功率',
      totalGeneratedElectricity: '微网发电量构成',
      microgridTDComparison: '微网分时发电量',
      fdfdl: '风电发电量',
      fsfdl: '峰时发电量',
      gsfdl: '谷时发电量',
      psfdl: '平时发电量',
      fdfdgl: '风电发电功率',
      zrl: '总容量',
      gf: '光伏',
      fd: '风电',
      zjrl: '装机容量',
      fdl: '发电量',
      daylyPower: '日发电量',
  },
  evcMonitoring: {
      top1 : '充电桩总量(个)',
      top2 : '充电中(个)',
      top3: '未充电(个)',
      top4: '离线(个)',
      top5: '故障(个)',
      title: '充电桩监控情况',
      no: '编号：',
      online: '在线',
      offline: '离线',
      fault: '故障',
      model: '枪口类型',
      status: '状态',
      price: '单价',
      shishi: '充电电流',
      leiji: '充电功率',
      money: '充电金额',
      yuan: '￥',
      weichongdian: '未充电',
      chongdianzhong: '充电中',
      lixian: '离线',
      guzhang: '故障',
  },
  storageOverview: {
      dianzhanqingkuang : '电站情况',
      dianzhanqingkuang_1 : '储能总容量',
      dianzhanqingkuang_2: '储能总功率',
      dianzhanqingkuang_3: '总放电量',
      dianzhanqingkuang_4: '储能模块机数量',
      dianzhanqingkuang_5: '总充放电功率',
      dianzhanqingkuang_6: '总充电量',
      wan: '万',
      chunengshouyi: '储能收益情况',
      danweiwanquan: '单位:万元',
      chongfangdian: '充放电量统计',
      chongdianliang: '充电量',
      fangdianliang: '放电量',
      chunengxitong: '储能系统概况',
      dianchiqingkuang: '电池情况',
      tanceqi_guzhang0: '系统正常',
      tanceqi_guzhang1: '灭火器已启动',
      tanceqi_guzhang2: '传感器故障',
      tanceqi_guzhang3: '硬件故障',
      chuanganqi_tongxin_guzhang0: '正常',
      chuanganqi_tongxin_guzhang1: '故障',
      day:'日',
      month: '月',
      year: '年',
      kt_snhfwd: '室内回风温度',
      kt_snhfsd: '室内回风湿度',
      kt_hjwd: '冷凝/环境温度',
      kt_zfwd: '蒸发温度',
      kt_jssc: '冷凝风机输出/加湿器输出',
      xf_tcqywdy: '探测器1-温度1',
      xf_tcqycond: '探测器1-CO浓度',
      xf_tcqyqtnd: '探测器1-气体浓度',
      xf_tcqyhqyjjb: '探测器1-火情预警级别',
      xf_tcqewdy: '探测器2-温度1',
      xf_tcqecond: '探测器2-CO浓度',
      xf_tcqeqtnd: '探测器2-气体浓度',
      xf_tcqehqyjjb: '探测器2-火情预警级别',
      xf_tcqywde: '探测器1-温度2',
      xf_tcqygzm: '探测器1故障码',
      xf_tcqewde: '探测器2-温度2',
      xf_tcqegzm: '探测器2故障码',
      cng_wd: '温度',
      cng_sd: '湿度',
      cng_gz: '传感器通信故障',
  },
  storageMonitor: {
      dianchicu: '电池簇',
      pcs_yxzt0: '停机',
      pcs_yxzt1: '待机',
      pcs_yxzt2: '故障',
      pcs_yxzt3: '充电',
      pcs_yxzt4: '放电',
      pcs_yxzt5: '充电降功率',
      pcs_yxzt6: '放电降功率',
      battery_run_state0: '停机',
      battery_run_state1: '运行充电',
      battery_run_state2: '运行放电',
      battery_run_state3: '待机',
      battery_run_state4: '故障',
      bms_state1: '正常',
      bms_state2: '预警',
      bms_state3: '告警',
      bms_state4: '保护',
      pcs_uab: '电网电压Uab',
      pcs_ubc: '电网电压Ubc',
      pcs_uca: '电网电压Uca',
      pcs_ia: 'A相电流值',
      pcs_ib: 'B相电流值',
      pcs_ic: 'C相电流值',
      pcs_lwpl: '离网频率',
      pcs_pl: '频率',
      pcs_jlldl: '交流漏电流(预留)',
      pcs_zldy: '直流电压',
      pcs_zldl: '直流电流',
      pcs_zzlgl: '总直流功率',
      pcs_scszgl: '输出视在功率',
      pcs_p: '总有功功率P',
      pcs_q: '总无功功率Q',
      pcs_yxzt: 'PCS运行状态',
      pcs_zcdl: 'PCS总充电量',
      pcs_zfdl: 'PCS总放电量',
      pcs_rcdl: '日充电量',
      pcs_rfdl: '日放电量',
      pcs_glys: '功率因数',
      pcs_nbwd: '内部温度',
      pcs_srqwd: '散热器温度',
      bms_soc: 'SOC',
      bms_soh: 'SOH',
      bms_dccyxzt: '电池簇运行状态',
      bms_zt: 'BMS状态',
      bms_v: '总电压',
      bms_i: '电流',
      bms_zgdtdy: '最高单体电压',
      bms_zddtdy: '最低单体电压',
      bms_zgwd: '最高温度',
      bms_zdwd: '最低温度',
      bms_zgsoc: '最高SOC',
      bms_zdsoc: '最低SOC',
      bms_zgdtdybh: '最高单体电压编号',
      bms_zddtdybh: '最低单体电压编号',
      bms_zgwdbh: '最高温度编号',
      bms_zdwdbh: '最低温度编号',
      bms_zdrxcddl: '最大允许充电电流',
      bms_zdrxfddl: '最大允许放电电流',
      bms_cndtdygs: '簇内单体电压个数',
      bms_cndtwdgs: '簇内单体温度个数',
      bms_zddywd: '电池组最大电压电池温度',
      bms_zxdywd: '电池组最小电压电池温度',
      bms_zdwddy: '电池组最大温度电池电压',
      bms_zxwddy: '电池组最小温度电池电压',
      bms_cddlfz: '电池组充电电流限值',
      bms_fddlfz: '电池组放电电流限值',
  }
}
